<template>
  <div class="image-overlay">
    <img
      v-lazy="imageSrc"
      v-bind:alt="imageAlt"
      v-bind:width="imageWidth"
      v-bind:height="imageHeight"
    >
    <div class="overlay">
      <div class="text">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageOverlay',
  props: {
    'image-src': {type: String},
    'image-alt': {
      type: String,
      default: null
    },
    'image-width': {
      type: Number,
      default: null
    },
    'image-height': {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .image-overlay {
    position: relative;
    & > img {
      display: block;
      width: 100%;
      height: auto;
      @media only print {
        width: auto;
        max-width: 80%;
        max-height: 50vh;
        margin: 0 auto;
      }
    }
    & > .overlay {
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      @media only print {
        position: static;
      }
      & > .text {
        padding: 1em;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @media only print {
          position: static;
          transform: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/utils/ImageOverlay.vue